const STRINGS = {
  header: {
    support: 'Служба поддержки Maya'
  },
  footer: {
    logout: 'Выход',
    change_language: 'Изменить язык',
  },
  content: {
    transaction_type: 'Тип продукта',
    product: 'Продукт',
    details: 'Детали',
    review: 'Подтверждение'
  },
};

export default STRINGS;


// WEBPACK FOOTER //
// ./src/i18n/ru_RU.js